import { Box, Autocomplete, TextField, Chip } from "@mui/material";
import { EmploymentTypes } from "../../Constants";
import { useState } from "react";
import WorkIcon from "@mui/icons-material/Work";

function FilterByType({ onChecked }) {
  const [selectedTypes, setSelectedTypes] = useState([]);

  const handleChange = (event, newValue) => {
    setSelectedTypes(newValue);
    onChecked(newValue.map((type) => type.label));
  };

  return (
    <Autocomplete
      multiple
      value={selectedTypes}
      onChange={handleChange}
      options={EmploymentTypes}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      sx={{
        flex: 1,
        minWidth: { md: "300px" },
        "& .MuiOutlinedInput-root": {
          "&:hover": {
            "& > fieldset": {
              borderColor: "primary.main"
            }
          }
        }
      }}
      size="small"
      renderOption={(props, option) => (
        <Box component="li" {...props}>
          {/* <WorkIcon sx={{ mr: 1, color: 'primary.main' }} /> */}
          {option.label}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Employment Type"
          placeholder="Select employment types"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                {selectedTypes.map((type) => (
                  <Chip
                    key={type.label}
                    // icon={<WorkIcon />}
                    size="small"
                    label={type.label}
                    onDelete={() => {
                      const newTypes = selectedTypes.filter((t) => t.label !== type.label);
                      setSelectedTypes(newTypes);
                      onChecked(newTypes.map((t) => t.label));
                    }}
                    color="primary"
                    sx={{ mr: 1 }}
                  />
                ))}
                {/* {params.InputProps.startAdornment} */}
              </>
            )
          }}
        />
      )}
      clearOnBlur
      handleHomeEndKeys
      selectOnFocus
    />
  );
}

export default FilterByType;
